import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import {
  Item,
  Title,
  Subtitle,
  Price,
  IconWrapper,
  Counter,
  Summary,
  Publications,
  Description,
  IconTrash,
  TabItem,
  Subtotal,
  Day,
  Content,
  SubtotalPrice,
  Available
} from './styled';
import {
  PublicationModel,
  deletePrintAllByChannel,
  setExtracharge,
  clearExtracharge,
  clearPhotoVignette,
  setPhotoVignetteAll,
  selectExtracharge,
} from '@app/src/views/StepTwo/channelPublication';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';
import { addDateSelectedAll, deleteAllDateSelected, setCalendarDate } from '@app/src/common/datePicker/state/calendar/actions';
import { isClientEnv } from '@app/src/utils/validations';
import { setPriceTotalByChannel } from '@app/src/views/StepOne/form';

interface Props {
  title?: string;
  day?: string;
  priceIgv?: number;
  details?: PublicationModel[];
  idChannel?: number;
  printData?: any;
  handleClickItem?: Function;
  priceSubTotal?: string;
  extra?: any;
  available?: number;
  idNewspaper?: number;
}

const isClient = isClientEnv();

export const OptionChannel: React.FC<Props> = ({
  title,
  day,
  priceIgv,
  details,
  idNewspaper,
  printData,
  handleClickItem,
  priceSubTotal,
  extra,
  available,
  idChannel
}) => {
  const dispatch = useDispatch();

  const publicationLabel = details && details.length == 1 ? 'Publicación' : 'Publicaciones';
  const idPrint = printData && printData.id;
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const dateSelected = printsByChannel && printsByChannel[idChannel];
  const print = useSelector(state => state.print);
  const extrachargesData = useSelector(state => state.extracharge.data);
  const typeUserAction = useSelector(state => state.session.user.pasarella);
  const extracharges = useSelector(state => state.extracharge.data[idPrint]);
  const printPhotoVignette = useSelector(state => state.print.photoVignette);
  const [countByChannel, setCountByChannel] = useState(0);
  const [open, setOpen] = useState(false);
  const [extrachargeSelected, setExtrachargeSelected] = useState([]);
  const availableCounter = useSelector(state => state.myPackageAvailable.counter);
  const availableByNewspaper = availableCounter && availableCounter[idNewspaper];
  const counterBoth = availableCounter && availableCounter.both;
  const [isClearExtracharges, setIsClearExtracharges] = useState(false);
  let currentDateSelected = dateSelected;

  useEffect(() => {
    if (available) {
      const countByChannel = getPrintsByChannelUnique(idNewspaper) || 0;
      setCountByChannel(countByChannel);
    }
  }, [printsByChannel, available]);

  useEffect(() => {
    if (printPhotoVignette && Object.keys(printPhotoVignette).length > 0) {
      dispatch(setPhotoVignetteAll(printPhotoVignette));
    }
  }, [printPhotoVignette]);

  useEffect(() => {
    if (print && print.extracharges && print.extracharges[idChannel] && print.extracharges[idChannel].data && print.extracharges[idChannel].data.length > 0) {
      dispatch(setExtracharge(idChannel, print.extracharges[idChannel].data));
    } else {
      if (extra && idChannel && extra[idChannel] && extra[idChannel].data) {
        dispatch(setExtracharge(idChannel, extra[idChannel].data));
      } else {
        dispatch(setExtracharge(idChannel, printData.extracharge));
      }
    }
  }, []);

  useEffect(() => {
    if (extracharges && extracharges.data && extracharges.data.length > 0) {
      const selecteds = extracharges.data.filter(item => (item.checked === true));
      setExtrachargeSelected(selecteds);
    }
  }, [extracharges]);

  const getPrintsByChannelUnique = (channelId) => {
    const currentData = Object.keys(printsByChannel);
    const byChannel = { 1: [], 2: [], 3: [] };
    if (currentData && currentData.length > 0) {
      currentData.map(item => {
        printsByChannel[item].map(el => {
          if (el) {
            byChannel && byChannel[el && el.newspaperId] && byChannel[el && el.newspaperId].push(el);
          }
        })
      })
      return byChannel[channelId] && byChannel[channelId].length;
    }
  };

  const handleAddDay = useCallback(
    (date: DateSelectedType) => dispatch(addDateSelectedAll(date, printData.id)),
    [dispatch]
  );

  const handleClickOpen = () => {
    handleClickItem && handleClickItem();
    handleSetCalendarDate();
    if (dateSelected && dateSelected.length > 0) {
      handleAddDay(dateSelected);
    }
    setOpen(!open);
  };

  const handleSetCalendarDate = useCallback(
    () => dispatch(setCalendarDate(printData)),
    [dispatch]
  );

  const handleClickDelete = useCallback(() => {
    const isDiscard = confirm('Todos los cambios se borrarán, ¿desea seguir con la acción?');
    if (isDiscard) {
      dispatch(deletePrintAllByChannel(idChannel));
      dispatch(clearPhotoVignette(idChannel));
      dispatch(deleteAllDateSelected(idChannel));
      if (typeUserAction === 'consume-print') {
        setIsClearExtracharges(true);
      } else {
        dispatch(clearExtracharge(idChannel));
        dispatch(setPriceTotalByChannel(idChannel, { price: 0, priceIgv: 0 }));
      }
      isClient && sessionStorage.setItem('print', JSON.stringify(print));
    }
  }, [extracharges, printsByChannel]);

  useEffect(() => {
    if (printsByChannel[idChannel] && printsByChannel[idChannel].length === 0 && extrachargeSelected && extrachargeSelected.length > 0 && isClearExtracharges) {
      setIsClearExtracharges(false);
      for (let i = 0; i < extrachargeSelected.length; i++) {
        const selected = extrachargeSelected[i];
        let printsAllWithExtra = getPrintsRestNewspaperByExtracharge(selected.extrachargeId, idNewspaper) + (printsByChannel[idChannel].length);
        let currentAvailableExtra = availableByNewspaper.extra && availableByNewspaper.extra[selected.extrachargeId];
        const group = { 1: [1, 3], 2: [2, 4, 5] };
        const currentGroup = group[idNewspaper];
        const groupBoth = { 1: 2, 2: 1 };
        const isInBoth = counterBoth && counterBoth.hasOwnProperty(selected.extrachargeId);

        if (isInBoth) {
          printsAllWithExtra = getPrintsRestAllBothNewspaperByExtracharge(selected.extrachargeId) + printsByChannel[idChannel].length;
          currentAvailableExtra = counterBoth[selected.extrachargeId];
        }

        currentGroup.map((channel) => {
          const currentExtras = extrachargesData[channel].data;

          if (channel === idChannel && printsByChannel[idChannel].length === 0) {
            dispatch(selectExtracharge(channel, selected.extrachargeId, false, currentAvailableExtra - printsAllWithExtra));
          } else {
            const beforeItem = currentExtras.filter(x => x.extrachargeId === selected.extrachargeId)[0];

            dispatch(selectExtracharge(channel, selected.extrachargeId, beforeItem.checked, currentAvailableExtra - printsAllWithExtra));
          }
        });
        if (counterBoth && counterBoth[selected.extrachargeId]) {
          const lastNewspaper = groupBoth[idNewspaper];
          const alternGroup = group[lastNewspaper];

          alternGroup.map(channel => {
            const currentExtras = extrachargesData[channel].data;
            const beforeItem = currentExtras.filter(x => x.extrachargeId === selected.extrachargeId)[0];
            dispatch(selectExtracharge(channel, selected.extrachargeId, beforeItem.checked, currentAvailableExtra - printsAllWithExtra));
          });
        }
      }
    }
  }, [printsByChannel, extrachargeSelected, isClearExtracharges, currentDateSelected]);

  const getPrintsRestNewspaperByExtracharge = (extrachargeId, newspaperId) => {
    const group = { 1: [1, 3], 2: [2, 4, 5] };
    const currentGroup = group[newspaperId];
    let count = 0;

    currentGroup.map(channel => {
      const extraSelecteds = extrachargesData[channel].data.filter(item => item.checked === true);
      extraSelecteds.map(selected => {
        if (selected.extrachargeId === extrachargeId) {
          if (channel !== idChannel) {
            count = count + (printsByChannel[channel] && printsByChannel[channel].length || 0)
          }
        }
      })
    });
    return count;
  };

  const getPrintsRestAllBothNewspaperByExtracharge = (extrachargeId) => {
    const groupBoth = { 1: 2, 2: 1 };
    const complementNewspaperId = groupBoth[idNewspaper];
    const printsRestNewspaperWithExtra = getPrintsRestNewspaperByExtracharge(extrachargeId, idNewspaper);
    const printsComplementNewspaperWithExtra = getPrintsRestNewspaperByExtracharge(extrachargeId, complementNewspaperId);
    return printsRestNewspaperWithExtra + printsComplementNewspaperWithExtra;
  };

  return (
    <Item>
      <TabItem onClick={handleClickOpen}>
        <Title>{`Clasificados ${title}`}{day && <Day> - {day}</Day>} {
          available && <Available>{available - countByChannel} Disponible(s) </Available>
        }</Title>
        {priceIgv ? <Subtitle>Precio por publicación desde <Price>{`S/ ${priceIgv}`}</Price></Subtitle> : null}
        <IconWrapper>
          {details && details.length > 0 && <Counter color={COLORS.BLUE_LINK}>{details.length}</Counter>}
          <Icon data-name="icon-expand-more" fill={COLORS.BLUE_LINK} width="9" height="9" />
        </IconWrapper>
      </TabItem>
      {
        details && details.length > 0 &&
        <Summary>
          <Publications>{details.length} {publicationLabel}</Publications>
          <Content>
            {details && details.map((item, index) => (
              <Description key={index}>{item.dateFormat}</Description>
            ))}
          </Content>
          {
            extrachargeSelected && extrachargeSelected.length > 0 &&
            <React.Fragment>
              <Publications>Extracargos</Publications>
              <Content>
                {
                  extrachargeSelected.map((item, index) => (
                    <Description key={index}>{item.name} x {details.length}</Description>
                  ))
                }
              </Content>
            </React.Fragment>
          }
          {priceSubTotal && <Subtotal>Sub Total<SubtotalPrice>S/ {priceSubTotal}</SubtotalPrice></Subtotal>}
          <IconTrash onClick={handleClickDelete}>
            <Icon data-name="icon-trash" fill={COLORS.BLACK_BOLD} width="16" height="16" />
          </IconTrash>
        </Summary>
      }
    </Item>
  )
};
